<template>
  <div class="lp-adm-btn-container">
    <div class="lp-adm-btn" :style="btnStyle" @click="$emit('onClick')">{{ data }}</div>
  </div>
</template>

<script>
export default {
  props: ['data', 'deco'],
  data() {
    return {

    }
  },
  computed: {
    btnStyle() {
      let style = {
        backgroundColor: this.deco.background,
        color: this.deco.color,
        border: '1px solid ' + this.deco.borderColor,
        fontSize: this.deco.fontSize,
        borderRadius: '3px',
        cursor: 'pointer',
        padding: '8px 20px',
        display: 'inline-block'
      };

      return style;
    }
  }
}
</script>

<style lang="stylus" type="stylus" scoped>
.lp-adm-btn
  font-size .9rem
  paddind 8px 20px
</style>
